import React from 'react';
import BookmarkAltIcon from '@heroicons/react/outline/BookmarkAltIcon.js';
import { BlockType } from '../../types/index.js';
import { LinkMenuBlock as Component } from './Block.js';
import { LinkMenuBlockSettings as Settings } from './Settings.js';
export const RegisteredLinkMenuBlock = (intl) => {
    const { $t } = intl;
    return {
        recommendedName: 'LinkMenu',
        Component,
        config: {
            type: BlockType.Block,
            usable: true,
            displayName: $t({
                id: 'Blocks.LinkMenu.DisplayName',
                defaultMessage: 'Link Menu',
            }),
            Settings,
            Icon: React.createElement(BookmarkAltIcon, null),
            defaultProps: {
                items: [
                    {
                        text: $t({ id: 'Generics.Home', defaultMessage: 'Home' }),
                        href: '/',
                        image: {
                            id: ':heart_eyes:',
                            text: 'heart_eyes',
                        },
                    },
                    {
                        text: $t({
                            id: 'Generics.Notifications',
                            defaultMessage: 'Notifications',
                        }),
                        href: '/notifications',
                        image: {
                            id: ':yum:',
                            text: 'yum',
                        },
                    },
                    {
                        text: $t({ id: 'Generics.Spaces', defaultMessage: '{SPACES_CC}' }),
                        href: '/spaces',
                        image: {
                            id: ':yum:',
                            text: 'yum',
                        },
                    },
                ],
            },
        },
    };
};
//# sourceMappingURL=registered.js.map